<h1 mat-dialog-title><strong>Ajouter au groupe</strong></h1>
<form (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="d-grid">
      <syn-group-picker (addGroup)="addGroup($event)" class="mt-3" />
      @if (isEmptyGroupList) {
      <div class="pb-3">Aucun groupe disponible. Veuillez créer un groupe.</div>
      }
      <div class="d-flex flex-row">
        @if (send) {
        <div class="spinner-border text-primary ms-3 mt-4" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        }
      </div>
    </div>
  </div>
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button mat-dialog-close>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!this.groupList">Ajouter</button>
  </mat-dialog-actions>
</form>
